import stateOptions from '../options/state';
import genderOptions from '../options/gender';

const updateUserFields = {
  name: {
    value: '',
    error: null,
    name: 'name',
    placeholder: 'Name',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  email: {
    value: '',
    error: null,
    name: 'email',
    placeholder: 'Email Address',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: 'email',
    hasBlurred: false,
    inputType: 'text',
  },
  address1: {
    value: '',
    error: null,
    name: 'address1',
    placeholder: 'Street Address',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  postal_code: {
    value: '',
    error: null,
    name: 'postal_code',
    placeholder: 'Zip Code',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  city: {
    value: '',
    error: null,
    name: 'city',
    placeholder: 'City',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  state: {
    value: '',
    error: null,
    name: 'state',
    placeholder: 'State',
    breed: 'select',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
    options: stateOptions,
    displayValue: '',
    isActive: false
  },
  phone: {
    value: '',
    error: null,
    name: 'phone',
    placeholder: 'Phone',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: 'phone',
    hasBlurred: false,
    inputType: 'text',
  },
  birthday: {
    value: '',
    error: null,
    name: 'birthday',
    placeholder: 'Birthday',
    breed: 'input',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  gender: {
    value: '',
    error: null,
    name: 'gender',
    placeholder: 'Gender',
    breed: 'select',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
    options: genderOptions,
    displayValue: '',
    isActive: false
  },
  text_message: {
    value: false,
    error: null,
    name: 'text_message',
    placeholder: 'Text Message',
    breed: 'toggle',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  push_notifications: {
    value: false,
    error: null,
    name: 'push_notifications',
    placeholder: 'Push Notification',
    breed: 'toggle',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  },
  unsubscribe: {
    value: false,
    error: null,
    name: 'unsubscribe',
    placeholder: 'Unsubscribe',
    breed: 'toggle',
    touched: false,
    isRequired: true,
    validationType: null,
    hasBlurred: false,
    inputType: 'text',
  }
}

export default updateUserFields;



/** WEBPACK FOOTER **
 ** ./src/forms/member/update.js
 **/